<template>
    <div v-if="!isFetching">
        <div
            v-if="!groups.data.length"
            class="box-body with-border clearfix"
        >
            <p>There are no Source Number Release Groups for this Api.</p>
        </div>
        <div v-else>
            <div class="box-body table-responsive no-padding">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th v-if="withApis">API</th>
                            <th>File</th>
                            <th>Numbers</th>
                            <th class="text-center">Status</th>
                            <th class="text-right">Created At</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="group in groups.data"
                            :key="group.id"
                        >
                            <td>{{ group.id }}</td>
                            <td>{{ group.name }}</td>
                            <td v-if="withApis">
                                <a :href="getRoute(group.api.id, 'apiShow')">
                                    <span
                                        :class="ifActive(group.api.active, 'text-red')"
                                        :title="ifActive(group.api.active, 'Disabled')"
                                    >
                                        {{ group.api.name }}
                                    </span>
                                </a>
                            </td>
                            <td>
                                <a
                                    v-if="group.has_file"
                                    :href="getRoute(group.id, 'download')"
                                >
                                    {{ group.original_name }}
                                </a>
                                <em
                                    v-else
                                    class="text-info"
                                    >Lost</em
                                >
                            </td>
                            <td>
                                <BadgeTotal
                                    :value="group.numbers_count"
                                    color="gray"
                                    title="Total"
                                />
                                <BadgeTotal
                                    :value="group.numbers_ready"
                                    color="green"
                                    title="Ready"
                                />
                                <BadgeTotal
                                    :value="group.numbers_released"
                                    color="red"
                                    title="Released"
                                />
                            </td>
                            <td class="text-center">
                                <span :class="'label bg-' + group.status_color">
                                    {{ group.status_formatted }}
                                </span>
                            </td>
                            <td class="text-right">
                                {{ group.created_at }}
                            </td>
                            <td class="text-right">
                                <a
                                    :href="getRoute(group.id, 'show')"
                                    class="btn btn-sm btn-info"
                                >
                                    <i class="fa fa-eye"></i>
                                    <span class="sr-only">Show</span>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div
                class="box-footer clearfix"
                @click="preventEnter"
                @keydown="preventEnter"
            >
                <pagination
                    :class="isDisabled()"
                    :data="groups"
                    :limit="$root.paginator.settings.limit"
                    :size="$root.paginator.settings.size"
                    class="pull-right no-margin vue-pagination"
                    show-disabled
                    @pagination-change-page="getData"
                >
                    <span slot="prev-nav">
                        <i class="fa fa-angle-double-left"></i>
                    </span>
                    <span slot="next-nav">
                        <i class="fa fa-angle-double-right"></i>
                    </span>
                </pagination>
            </div>
        </div>
    </div>
    <!-- /.box-body -->
</template>

<script>
import BadgeTotal from '../subcomponents/BadgeTotal';

export default {
    components: {
        BadgeTotal,
    },
    props: {
        apiId: {
            type: Number,
            default: null,
        },
        withApis: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            groups: {},
            disablePagination: true,
            isFetching: true,
            pageNumber: this.$route.query.page,
            route: {
                apiShow: '/apis/:id:',
                show: '/asn/groups/release/:id:',
                download: '/asn/groups/release/:id:/download',
            },
        };
    },
    mounted() {
        this.getData(this.pageNumber);
    },
    methods: {
        preventEnter: function (event) {
            if (this.disablePagination) {
                return event.preventDefault();
            }
        },
        getData: function (page = 1) {
            this.disablePagination = true;
            axios.get('/apis/' + this.apiId + '/data-release-groups?page=' + page).then((response) => {
                if (String(page) !== String(this.$route.query.page)) {
                    this.$router.push({ query: Object.assign({}, this.$route.query, { page: String(page) }) });
                }

                if (page > response.data.groups.last_page) {
                    return this.getData();
                }

                this.groups = response.data.groups;
                this.isFetching = false;
                this.disablePagination = false;
            });
        },
        getRoute: function (id, type) {
            return this.route[type].replace(':id:', id);
        },
        ifActive: function (value, text) {
            return value ? '' : text;
        },
        isDisabled: function () {
            return this.disablePagination ? 'disabled-box' : '';
        },
    },
};
</script>
